// Stock management functionality
import { setLoadingState, resetLoadingState, setupInfiniteScroll, setupGenericSearch } from '../../utils/common.js';

// Stock functionality
$(document).ready(function() {
    // Initialize stock list with infinite scroll
    if ($('.tbodyStock').length) {
        setupInfiniteScroll('.tbodyStock', '/estoque/carregar-mais', '#currentPage');
    }
    
    // Initialize search functionality
    if ($('#searchStock').length) {
        setupGenericSearch('#searchStock', '#stockList', '/estoque/buscar');
    }
    
    // Handle stock item form submission
    $('#stockItemForm').on('submit', function(e) {
        e.preventDefault();
        handleStockItemSubmission(this);
    });
    
    // Handle stock movement form submission
    $('#stockMovementForm').on('submit', function(e) {
        e.preventDefault();
        handleStockMovementSubmission(this);
    });
    
    // Handle barcode scanner
    if ($('#barcodeScanner').length) {
        initializeBarcodeScanner();
    }
    
    // Handle supplier loading
    if ($('#supplierSelect').length) {
        loadSuppliers();
    }
    
    // Handle low stock alerts
    checkLowStockItems();
    
    // Handle stock adjustment
    $('.stock-adjustment-btn').on('click', function() {
        const itemId = $(this).data('item-id');
        openStockAdjustmentModal(itemId);
    });
    
    // Handle quick stock update
    $('.quick-stock-update').on('blur', function() {
        const itemId = $(this).data('item-id');
        const newQuantity = $(this).val();
        updateStockQuantity(itemId, newQuantity);
    });
});

function handleStockItemSubmission(form) {
    const submitBtn = $(form).find('button[type="submit"]');
    setLoadingState(submitBtn);
    
    const formData = new FormData(form);
    
    $.ajax({
        url: $(form).attr('action'),
        method: $(form).find('input[name="_method"]').val() || 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            if (response.success) {
                showSuccessMessage('Item de estoque salvo com sucesso!');
                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    location.reload();
                }
            } else {
                showErrorMessage(response.message || 'Erro ao salvar item de estoque');
            }
        },
        error: function(xhr) {
            if (xhr.status === 422) {
                const errors = xhr.responseJSON.errors;
                displayValidationErrors(errors);
            } else {
                const errorMessage = xhr.responseJSON?.message || 'Erro interno do servidor';
                showErrorMessage(errorMessage);
            }
        },
        complete: function() {
            resetLoadingState(submitBtn);
        }
    });
}

function handleStockMovementSubmission(form) {
    const submitBtn = $(form).find('button[type="submit"]');
    setLoadingState(submitBtn);
    
    const formData = new FormData(form);
    
    $.ajax({
        url: $(form).attr('action'),
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            if (response.success) {
                showSuccessMessage('Movimentação de estoque registrada!');
                $('#stockMovementModal').modal('hide');
                location.reload();
            } else {
                showErrorMessage(response.message || 'Erro ao registrar movimentação');
            }
        },
        error: function(xhr) {
            const errorMessage = xhr.responseJSON?.message || 'Erro interno do servidor';
            showErrorMessage(errorMessage);
        },
        complete: function() {
            resetLoadingState(submitBtn);
        }
    });
}

function initializeBarcodeScanner() {
    if (typeof Html5QrcodeScanner !== 'undefined') {
        const scanner = new Html5QrcodeScanner(
            "barcodeScanner",
            { fps: 10, qrbox: { width: 250, height: 250 } },
            false
        );
        
        scanner.render(onScanSuccess, onScanFailure);
        
        function onScanSuccess(decodedText, decodedResult) {
            searchItemByBarcode(decodedText);
            scanner.clear();
        }
        
        function onScanFailure(error) {
            // Handle scan failure silently
        }
    }
}

function searchItemByBarcode(barcode) {
    $.ajax({
        url: '/estoque/buscar-por-codigo',
        method: 'GET',
        data: { barcode: barcode },
        success: function(response) {
            if (response.success && response.data) {
                fillItemForm(response.data);
                showSuccessMessage('Item encontrado!');
            } else {
                showErrorMessage('Item não encontrado no estoque');
            }
        },
        error: function(xhr) {
            showErrorMessage('Erro ao buscar item por código de barras');
        }
    });
}

function fillItemForm(itemData) {
    $('#itemName').val(itemData.nome);
    $('#itemCode').val(itemData.codigo);
    $('#itemBarcode').val(itemData.codigo_barras);
    $('#itemPrice').val(itemData.preco);
    $('#itemQuantity').val(itemData.quantidade);
    $('#itemMinQuantity').val(itemData.quantidade_minima);
    $('#supplierSelect').val(itemData.fornecedor_id);
}

function loadSuppliers() {
    $.ajax({
        url: '/fornecedores/listar',
        method: 'GET',
        success: function(response) {
            const supplierSelect = $('#supplierSelect');
            supplierSelect.empty().append('<option value="">Selecione um fornecedor</option>');
            
            response.data.forEach(function(supplier) {
                supplierSelect.append(`<option value="${supplier.id}">${supplier.nome}</option>`);
            });
        },
        error: function(xhr) {
        }
    });
}

function checkLowStockItems() {
    $.ajax({
        url: '/estoque/baixo-estoque',
        method: 'GET',
        success: function(response) {
            if (response.data && response.data.length > 0) {
                showLowStockAlert(response.data);
            }
        },
        error: function(xhr) {
        }
    });
}

function showLowStockAlert(items) {
    const itemsList = items.map(item => 
        `<li>${item.nome} - Estoque: ${item.quantidade} (Mín: ${item.quantidade_minima})</li>`
    ).join('');
    
    if (typeof Swal !== 'undefined') {
        Swal.fire({
            icon: 'warning',
            title: 'Alerta de Estoque Baixo',
            html: `<p>Os seguintes itens estão com estoque baixo:</p><ul class="text-left">${itemsList}</ul>`,
            confirmButtonText: 'Entendi'
        });
    }
}

function openStockAdjustmentModal(itemId) {
    $.ajax({
        url: `/estoque/${itemId}`,
        method: 'GET',
        success: function(response) {
            const modal = createStockAdjustmentModal(response.data);
            $('body').append(modal);
            $('#stockAdjustmentModal').modal('show');
        },
        error: function(xhr) {
            showErrorMessage('Erro ao carregar dados do item');
        }
    });
}

function createStockAdjustmentModal(item) {
    return `
        <div class="modal fade" id="stockAdjustmentModal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajustar Estoque - ${item.nome}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"><i class="sg sg-x"></i></button>
                    </div>
                    <form id="stockAdjustmentForm" action="/estoque/${item.id}/ajustar" method="POST">
                        <div class="modal-body">
                            <input type="hidden" name="_token" value="${$('meta[name="csrf-token"]').attr('content')}">
                            <div class="mb-3">
                                <label class="form-label">Quantidade Atual</label>
                                <input type="text" class="form-control" value="${item.quantidade}" readonly>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Tipo de Ajuste</label>
                                <select name="tipo_ajuste" class="form-select" required>
                                    <option value="">Selecione</option>
                                    <option value="entrada">Entrada</option>
                                    <option value="saida">Saída</option>
                                    <option value="ajuste">Ajuste Manual</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Quantidade</label>
                                <input type="number" name="quantidade" class="form-control" min="1" required>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Motivo</label>
                                <textarea name="motivo" class="form-control" rows="3" placeholder="Descreva o motivo do ajuste" required></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="submit" class="btn btn-primary" data-loading-text="Salvando...">Salvar Ajuste</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    `;
}

function updateStockQuantity(itemId, newQuantity) {
    $.ajax({
        url: `/estoque/${itemId}/quantidade`,
        method: 'PUT',
        data: {
            quantidade: newQuantity
        },
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            if (response.success) {
                showSuccessMessage('Quantidade atualizada!');
            } else {
                showErrorMessage(response.message || 'Erro ao atualizar quantidade');
            }
        },
        error: function(xhr) {
            const errorMessage = xhr.responseJSON?.message || 'Erro interno do servidor';
            showErrorMessage(errorMessage);
        }
    });
}

function displayValidationErrors(errors) {
    $('.is-invalid').removeClass('is-invalid');
    $('.invalid-feedback').remove();
    
    Object.keys(errors).forEach(function(field) {
        const input = $(`[name="${field}"]`);
        const errorMessage = errors[field][0];
        
        input.addClass('is-invalid');
        input.after(`<div class="invalid-feedback">${errorMessage}</div>`);
    });
}

// Stock filtering
function filterStock(filters) {
    $.ajax({
        url: '/estoque/filtrar',
        method: 'GET',
        data: filters,
        success: function(response) {
            $('#stockList').html(response.html);
        },
        error: function(xhr) {
            showErrorMessage('Erro ao filtrar estoque');
        }
    });
}

// Initialize stock filters
$(document).ready(function() {
    $('#filterCategory, #filterSupplier, #filterLowStock').on('change', function() {
        const filters = {
            category: $('#filterCategory').val(),
            supplier: $('#filterSupplier').val(),
            low_stock: $('#filterLowStock').is(':checked')
        };
        
        filterStock(filters);
    });
});

function showSuccessMessage(message) {
    if (typeof Swal !== 'undefined') {
        Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: message,
            timer: 3000,
            showConfirmButton: false
        });
    } else {
        alert(message);
    }
}

function showErrorMessage(message) {
    if (typeof Swal !== 'undefined') {
        Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: message
        });
    } else {
        alert(message);
    }
}

// Export functions for external use
export {
    handleStockItemSubmission,
    handleStockMovementSubmission,
    initializeBarcodeScanner,
    searchItemByBarcode,
    loadSuppliers,
    checkLowStockItems,
    updateStockQuantity,
    filterStock
};
